if (!customElements.get('upsell-modal')) {
  customElements.define(
    'upsell-modal',
    class UpsellModal extends ModalDialog {
      constructor() {
        super();
        this.addBtn = this.querySelector('.upsell-modal__add-btn');
        this.skipBtn = this.querySelector('.upsell-modal__skip-btn');
        this.track = this.querySelector('.upsell-modal__carousel-track');
        this.dots = this.querySelectorAll('.upsell-modal__carousel-dot');
        this.slides = this.querySelectorAll('.upsell-modal__carousel-slide');
        this.currentIndex = 0;
        this.autoplayTimer = null;

        this.addBtn.addEventListener('click', this.onAddToCart.bind(this));
        this.skipBtn.addEventListener('click', this.hide.bind(this));
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.stopAutoplay();
            this.goTo(i);
            this.startAutoplay();
          });
        });

        this.touchStartX = 0;
        const carousel = this.querySelector('.upsell-modal__carousel');
        if (carousel) {
          carousel.addEventListener('touchstart', (e) => {
            this.touchStartX = e.touches[0].clientX;
            this.stopAutoplay();
          }, { passive: true });
          carousel.addEventListener('touchend', (e) => {
            const delta = e.changedTouches[0].clientX - this.touchStartX;
            if (Math.abs(delta) >= 50) {
              const next = delta < 0
                ? (this.currentIndex + 1) % this.slides.length
                : (this.currentIndex - 1 + this.slides.length) % this.slides.length;
              this.goTo(next);
            }
            this.startAutoplay();
          }, { passive: true });
        }
      }

      show(opener) {
        super.show(opener);
        this.goTo(0);
        this.startAutoplay();
      }

      hide() {
        this.stopAutoplay();
        super.hide();
      }

      startAutoplay() {
        if (this.slides.length <= 1) return;
        this.autoplayTimer = setInterval(() => {
          this.goTo((this.currentIndex + 1) % this.slides.length);
        }, 5000);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      goTo(index) {
        this.currentIndex = index;
        if (this.track) {
          this.track.style.transform = `translateX(-${index * 100}%)`;
        }
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      getSelectedVariantId() {
        const checked = this.querySelector('input[name="UpsellVariant"]:checked');
        if (checked) return checked.value;
        const hidden = this.querySelector('#UpsellVariant');
        return hidden ? hidden.value : null;
      }

      onAddToCart() {
        const variantId = this.getSelectedVariantId();
        if (!variantId) return;

        this.addBtn.setAttribute('aria-disabled', 'true');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = {
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        };

        if (cart) {
          body.sections = cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',');
          body.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then(() => {
            window.location = window.routes.cart_url;
          })
          .catch((error) => {
            console.error('Upsell modal: cart add error', error);
          })
          .finally(() => {
            this.addBtn.removeAttribute('aria-disabled');
          });
      }
    },
  );
}
